import { ActionIcon, Box, Button, Group, Loader, Menu, Paper, Text, Title } from '@mantine/core';
import { Buffer } from 'buffer';
import moment from 'moment';
import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import { createMarkerIcon, downloadGPX, downloadKML, formatDuration } from '../utility/util';
import SimpleMap from './simple_map';
import { showNotification } from '@mantine/notifications';
import { GET_VEHICLE_TRAJECT } from '../services/vehicles';
import { useMediaQuery } from '@mantine/hooks';

export default function TrajectView({
    isVisible = false,
    onClose = null,
    vehicle = null,
    data = null
} = {}){
    const {
        start: startParams = null,
        finish: finishParams = null
    } = {...data};
    const [expandedHistory, setExpandedHistory] = React.useState<any>(null);
    const [loading, setLoading] = React.useState<any>(false);
    const [res, setRes] = React.useState<any>(null);

    const isMobile = useMediaQuery('(max-width: 900px)');

    useEffect(() => {
        if(isVisible && startParams && vehicle._id && finishParams){
            setLoading(true)
            GET_VEHICLE_TRAJECT(vehicle?._id, {start: startParams, finish: finishParams})
            .then((res) => {
                setLoading(false)
                setRes(res)
            })
            .catch(err => {
                setLoading(false)
                showNotification({ message: err.message, color: "red" })
            })
        }
    }, [isVisible, vehicle, startParams, finishParams]);

    const exportGPX = () => {
        let histories = (res?.history ?? [{}]);
        const start = moment(startParams);
        const finish = moment(finishParams);
    
        downloadGPX({
            start,
            finish,
            title: `${vehicle?.license_plate}_${moment().unix()}`,
            histories,
        })
    }
    
    const exportKML = () => {
        let histories = (res?.history ?? [{}]);
        const start = moment(startParams);
        const finish = moment(finishParams);
    
        downloadKML({
            start,
            finish,
            title: `${vehicle?.license_plate}_${moment().unix()}`,
            histories,
        })
    }

    return <Paper
        shadow="xs"
        style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
            transition: '0.6s all',
            left: isVisible ? isMobile ? 0 : '35vw' : '100vw',
            background: 'white',
            borderRadius: 0,
            borderColor: '#DFDFDF',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            padding: 0,
        }}
    >
        <Box p="xl">
            <Group align="flex-start" mb="xl">
                <Title style={{flex: 1}} order={3} mb="mt">{vehicle?.license_plate}</Title>
                <ActionIcon color="gray" variant="outline" onClick={() => {
                    onClose();
                }}><FaTimes /></ActionIcon>
            </Group>

            {loading
                ? <Loader mb="xl" />
                : (res?.history ?? []).length === 0 && <Title fw="normal" mt="xl" mb="xl" order={3}>Nenhum trajeto no período selecionado</Title>}

            <SimpleMap
                line
                onPoint={({ item, index }) => {
                    setExpandedHistory(index)
                }}
                markers={(res?.history ?? []).filter(p => p?.props?.location).map(p => p.props.location)}
                icons={
                    (res?.history ?? []).length > 0
                    ? [
                        { icon: createMarkerIcon("A"), ...(res?.history ?? [])[0]?.props?.location },
                        ...(res?.history ?? []).slice(1, (res?.history ?? []).length - 1)
                        .filter(h => h?.props?.location)
                        .map((h, i) => ({
                            icon: {
                                path: window.google.maps.SymbolPath.CIRCLE,
                                scale: 2,
                                strokeColor: expandedHistory === i+1 ? '#0000FF' : '#FF0000',
                            },
                            ...h?.props?.location,
                        })),
                        (res?.history ?? []).length > 1
                        ? { icon: createMarkerIcon("B"), ...(res?.history ?? [])[(res?.history ?? []).length - 1]?.props?.location }
                        : null,
                    ].filter(nn => nn)
                    : []
                }
                height={"500px"}
            />

            {(res?.history?? [])[expandedHistory] && <Paper p="md">
                {[
                    { title: "Horário do registro", value: moment((res?.history?? [])[expandedHistory].datetime).format("DD/MM/YYYY HH:mm:ss") },
                    { title: "Ignição", value: (res?.history?? [])[expandedHistory]?.props?.power
                        ? (res?.history?? [])[expandedHistory]?.props?.power === "on" ? "Ligada" : "Desligada"
                        : "Sem informação" },
                    { title: "Velocidade (km/h)", value: ![null, undefined].includes((res?.history?? [])[expandedHistory]?.props?.speed)
                        ? parseFloat((res?.history?? [])[expandedHistory]?.props?.speed).toFixed(2)
                        : "Sem informação" },
                    { title: "Odômetro", value: ![null, undefined].includes((res?.history?? [])[expandedHistory]?.props?.traveled_distance)
                        ? (parseFloat((res?.history?? [])[expandedHistory]?.props?.traveled_distance) / 1000).toFixed(2)
                        : "Sem informação" },
                    { title: "Velocidade Média (km/h)", value: ![null, undefined].includes((res?.history?? [])[expandedHistory]?.props?.speed_medium)
                        ? (parseFloat((res?.history?? [])[expandedHistory]?.props?.speed_medium) / 1000).toFixed(2)
                        : "Sem informação" },
                    { title: "Angulação do veículo", value: ![null, undefined].includes((res?.history?? [])[expandedHistory]?.props?.angle)
                        ? parseFloat((res?.history?? [])[expandedHistory]?.props?.angle).toFixed(2)
                        : "Sem informação" },
                    ].map(item =>   
                    <div style={{ padding: 10, borderBottom: "1px solid #EFEFEF", transition: '0.5s all' }}>
                        <Group>
                        <Text style={{flex: 1}}>{item.title}</Text>
                        <Text size="xs" align="right" color="gray" weight="bold">{item.value}</Text>
                        </Group>
                    </div>
                )}

            </Paper>}
            
            <div style={{display: 'flex', marginTop: 40, padding: '5px 0', flexDirection: 'row', width: '100%', overflowX: 'auto', flexWrap: 'nowrap'}}>
                {[
                    { 
                        value: `${((res?.totals?.hodometerDistance ?? 0)/1000).toFixed(2)} km`,
                        title: "Distância Percorrida" },
                    { 
                        value: `${formatDuration(res?.totals?.movingTime ?? 0)}`,
                        title: "Tempo Ligado" },
                    { 
                        value: `${formatDuration(res?.totals?.stoppedTime ?? 0)}`,
                        title: "Tempo Desligado" },
                    { 
                        value: `${(res?.totals?.trajects ?? []).length}`,
                        title: "Quantidade de Percursos" },
                    { 
                        value: `${res?.totals?.numStops ?? 0}`,
                        title: "Quantidade de Paradas" },
                    { 
                        value: `${(res?.totals?.maxSpeed ?? 0).toFixed(1)} km/h`,
                        title: "Velocidade Máxima" },
                    { 
                        value: `${(res?.totals?.mediumSpeed ?? 0).toFixed(1)} km/h`,
                        title: "Velocidade Média" },
                ].map(item => (
                    <Box mr="md" p="xs" style={{minWidth: 120, borderRadius: 5, border: '1px solid #DFDFDF', display: 'flex', flexDirection: 'column'}}>
                        <Text style={{flex: 1}} size={12} ta="center">{item.title}</Text>
                        <Text ta="center" size={16} weight='bold'>{item.value}</Text>
                    </Box>
                ))}
            </div>

            <Menu>
                <Menu.Target>
                    <Button
                        mt="xl"
                        disabled={(res?.history ?? []).length === 0}
                    >Exportar</Button>
                </Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item onClick={exportGPX}>Exportar GPX</Menu.Item>
                    <Menu.Item onClick={exportKML}>Exportar KML</Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </Box>

    </Paper>
}